import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-5 l:flex-row l:items-center l:gap-x-10" }

import BaseTypography from '@/components/common/BaseTypography.vue';
import LocaleSwitcher from '@/components/common/LocaleSwitcher.vue';
import { useI18n } from 'vue-i18n';
import { toRefs } from 'vue';
import { useGlobalStore } from '@/stores/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavMenu',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { t } = useI18n();

const globalStore = useGlobalStore();
const { isMobile } = toRefs(globalStore);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createVNode(BaseTypography, {
              text: _unref(t)('header.about'),
              type: "footnote",
              color: "var(--black-color)",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, null, 8, ["text"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/categories" }, {
          default: _withCtx(() => [
            _createVNode(BaseTypography, {
              text: _unref(t)('header.tours'),
              type: "footnote",
              color: "var(--black-color)",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            }, null, 8, ["text"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/excursions" }, {
          default: _withCtx(() => [
            _createVNode(BaseTypography, {
              text: _unref(t)('header.excursions'),
              type: "footnote",
              color: "var(--black-color)",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
            }, null, 8, ["text"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/contacts" }, {
          default: _withCtx(() => [
            _createVNode(BaseTypography, {
              text: _unref(t)('header.contacts'),
              type: "footnote",
              color: "var(--black-color)",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close')))
            }, null, 8, ["text"])
          ]),
          _: 1
        })
      ])
    ]),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(LocaleSwitcher, {
          key: 0,
          class: "mt-[60px]",
          color: "var(--black-color)"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})